import { render, staticRenderFns } from "./Suisho.html?vue&type=template&id=4023d257&scoped=true&"
import script from "./Suisho.vue?vue&type=script&lang=ts&"
export * from "./Suisho.vue?vue&type=script&lang=ts&"
import style0 from "../Notice.scss?vue&type=style&index=0&id=4023d257&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4023d257",
  null
  
)

export default component.exports